export default {
    articleNoPic: 11,
    articleOnePic: 10,
    list: 1,
    atlas: 20,

    cardTypeMap: {
        30: 'shopCardEnroll',
        32: 'shopCardEnroll',

        31: 'shopCardPhone',
        33: 'shopCardPhone',

        35: 'shopCardPoster',
        36: 'shopCardPoster',
        64: 'shopCardPoster',
        65: 'shopCardPoster',

        34: 'shopCardImgText',
        51: 'shopCardImgText',
        63: 'shopCardImgText',

        37: 'shopCardVideo',
        38: 'shopCardVideo',
        39: 'shopCardVideo',

        47: 'shopCardQrcode',
        66: 'shopCardVote', // 投票功能卡
        69: 'selfdefineCard', // 自定义功能卡
    },

    shopCard: [31, 30, 32, 33, 34, 35, 36, 37, 38, 39, 47, 51,63,64,65,66,69],
}